var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { classToPlain } from 'class-transformer';
import { $, call, clone, apiFullURL } from '../../helpers';
var HttpBody = /** @class */ (function () {
    function HttpBody(cls) {
        if (cls)
            this.cls = cls;
        else
            delete this.cls;
    }
    /**
     * Serializes the response body of a call to the WebServer
     * @param promise Any call of VUE RESOURCE
     */
    HttpBody.prototype.call = function (promise) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cls) return [3 /*break*/, 2];
                        return [4 /*yield*/, call(this.cls, promise)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, call(this, promise)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Serializes the response body of GET method to the WebServer
     * @param uri URI endpoint
     * @param options
     * @param endpoint
     */
    HttpBody.prototype.GET = function (uri, options, endpoint) {
        if (endpoint === void 0) { endpoint = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call($.http.get(endpoint ? apiFullURL(uri) : uri, options))];
            });
        });
    };
    /**
     * Serializes the response body of POST method to the WebServer
     * @param uri URI endpoint
     * @param body payload
     * @param options
     * @param endpoint
     */
    HttpBody.prototype.POST = function (uri, body, options, endpoint) {
        if (endpoint === void 0) { endpoint = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call($.http.post(endpoint ? apiFullURL(uri) : uri, classToPlain(body), options))];
            });
        });
    };
    /**
     * Serializes the response body of PUT method to the WebServer
     * @param uri URI endpoint
     * @param body payload
     * @param options
     * @param endpoint
     */
    HttpBody.prototype.PUT = function (uri, body, options, endpoint) {
        if (endpoint === void 0) { endpoint = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call($.http.put(endpoint ? apiFullURL(uri) : uri, classToPlain(body), options))];
            });
        });
    };
    /**
     * Serializes the response body of DELETE method to the WebServer
     * @param uri URI endpoint
     * @param endpoint
     * @param options
     */
    HttpBody.prototype.DELETE = function (uri, options, endpoint) {
        if (endpoint === void 0) { endpoint = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call($.http.delete(endpoint ? apiFullURL(uri) : uri, options))];
            });
        });
    };
    /**
     * Clone this entity
     */
    HttpBody.prototype.clone = function () {
        return clone(this);
    };
    return HttpBody;
}());
export { HttpBody };
//# sourceMappingURL=HttpBody.js.map